import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-left" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              (_ctx.treeItems.length)
                ? (_openBlock(), _createBlock(_component_v_treeview, {
                    key: 0,
                    class: "elevation-1 bg-blue-grey-lighten-4",
                    opened: _ctx.open,
                    "onUpdate:opened": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
                    items: _ctx.treeItems,
                    "item-value": "title",
                    density: "compact",
                    activatable: "",
                    "open-on-click": ""
                  }, {
                    prepend: _withCtx(({ item, isOpen }) => [
                      (!('file' in item))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            icon: isOpen ? 'mdi-folder-open' : 'mdi-folder'
                          }, null, 8, ["icon"]))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            icon: _ctx.files[item.file ?? ''] || 'mdi-file'
                          }, null, 8, ["icon"]))
                    ]),
                    _: 1
                  }, 8, ["opened", "items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: _ctx.activateDownload ? 2 : 0
          }, {
            default: _withCtx(() => [
              (_ctx.activateDownload)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "elevation-10 font-weight-light",
                    icon: "mdi-download",
                    size: "large",
                    color: "primary",
                    variant: "tonal",
                    onClick: _ctx.downloadZip
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}